// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2Mvqn","disabled":"FileBtn_disabled__24j6W","warn":"FileBtn_warn__2MStm","fade":"FileBtn_fade__1q1KB"};